export default __webpack_public_path__ + "static/media/closeSidebar.12bdff61.svg";